import axiosInstance from "./AxiosInstance";

export function unlockProfileList(data) {
  return axiosInstance.post(
    "editor/candidates/unlock-candidates/listing",
    data
  );
}

export function downloadResume(data) {
  return axiosInstance.post("editor/candidates/download-candidate-resume", data);
}

export function postLogout() {
  return axiosInstance.post("admin/user/logout", { user_type: "admin" });
}
